import { useState } from "react";
import Image from "next/image";
import appConfig from "@/config";
import DevLoginButtons from "./buttons/DevLoginButtons";
import GoogleLoginButton from "./buttons/GoogleLoginButton";
import MicrosoftLoginButton from "./buttons/MicrosoftLoginButton";
import AppleLoginButton from "./buttons/AppleLoginButton";
import { ResponsiveShowcase } from "@/containers/framerlanding/Hero";
import WhyAccountModal from "@/components/WhyAccountModal";

export default function AanmeldFormNative() {
  const [showDev, setShowDev] = useState(false);
  const [showWhy, setShowWhy] = useState(false);

  return (
    <>
      <div className="flex-1 flex flex-col bg-achtergrond min-h-0 overflow-hidden">
        <div className="flex justify-center pt-10">
          <Image
            src="/wiswizlogo.png"
            alt="WisWiz"
            width={180}
            height={81}
            priority
          />
        </div>

        <div className="flex-1 min-h-0 relative">
          <div className="absolute inset-0 flex items-center justify-center px-4">
            <ResponsiveShowcase />
          </div>
        </div>

        <div className="shrink-0 min-h-[33dvh] max-h-[75dvh] bg-white rounded-t-3xl px-6 md:px-12 pt-6 md:pt-8 pb-8 shadow-[0_-4px_20px_rgba(0,0,0,0.08)]">
          <div className="text-center pb-3 md:pb-5">
            <h2 className="text-xl md:text-2xl font-bold text-gray-900">
              Klaar om wiskunde te snappen?
            </h2>
            <div className="w-8 h-0.5 bg-mathyellow rounded-full mx-auto mt-2" />
            <p className="text-sm md:text-base text-gray-500 mt-2">
              Log in of maak een account aan met Google, Microsoft of Apple
            </p>
          </div>

          <div className="flex flex-col gap-3 md:gap-4 max-w-sm md:max-w-md mx-auto">
            <GoogleLoginButton />
            <MicrosoftLoginButton />
            <AppleLoginButton />
          </div>

          {appConfig.environment === "development" && (
            <div className="mt-3 text-center">
              <button
                onClick={() => setShowDev(!showDev)}
                className="text-xs text-gray-400 hover:text-gray-600"
              >
                dev_login
              </button>
              {showDev && <DevLoginButtons />}
            </div>
          )}

          <button
            onClick={() => setShowWhy(true)}
            className="mt-4 md:mt-6 text-sm md:text-base text-gray-400 hover:text-gray-600 transition-colors mx-auto block"
          >
            Waarom een account?
          </button>
        </div>
      </div>

      <WhyAccountModal open={showWhy} onClose={() => setShowWhy(false)} />
    </>
  );
}
